import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  GuestPicker,
  useHotelSearch,
  HotelLocationAutocomplete,
} from "@tenant/hotels";
import { ActionButton, DateRangePicker } from "../../../../../components";
import styles from "./HotelSearchBar.module.scss";

export const SearchBarContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [, cn] = useModuleBEM(styles, "HotelSearchBar");

  return <div className={cn("content")}>{children}</div>;
};
export const HotelSearchBar = () => {
  const { context, handlers } = useHotelSearch();
  const { t } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "HotelSearchBar");
  return (
    <SearchBarContainer>
      <HotelLocationAutocomplete
        label={context.locationLabel}
        value={context.place}
        onChange={handlers.handlePlaceChange}
        id={"hotel-location-autocomplete"}
        placeholder={t("lodging.search.autocomplete.placeholder")}
      />
      <DateRangePicker
        startDate={context.dateRange?.from}
        endDate={context.dateRange?.until}
        onStartDateChangeHandler={(date) => {
          handlers.handleDateRangeFromChange(date);
        }}
        onEndDateChangeHandler={(date) => {
          handlers.handleDateRangeUntilChange(date);
        }}
      />
      <GuestPicker
        className={cn("guest-picker-container")}
        onGuestSelectionHandler={handlers.handleGuestsChange}
        guests={context.guests}
        rooms={context.roomsCount}
        onRoomsSelectionHandler={handlers.handleRoomsCountChange}
      />
      <ActionButton
        disabled={!context.isFormValid}
        message={context.searchButtonLabel}
        className={cn("search-button")}
        onClick={(e) => {
          e.preventDefault();
          handlers.handleSearch();
        }}
      />
    </SearchBarContainer>
  );
};
